import { useRouter } from 'next/router';
import React, { ReactElement, useEffect, useState } from 'react';

import Sidebar from 'components/SignInSidebar';
import NotFound from 'pages/404/index.page';
import Form from './Form';

import styles from './Section.module.scss';

export const Section: React.FC<{ isRecruiter?: boolean }> = ({
  isRecruiter = false,
}): ReactElement => {
  const router = useRouter();
  const [token, setToken] = useState<string | string[] | undefined | null>(
    null
  );

  useEffect(() => {
    if (router.isReady) {
      const { resetPasswordToken } = router.query;
      setToken(resetPasswordToken);
    }
  }, [router]);

  if (token === undefined) {
    return <NotFound />;
  }

  if (token === undefined) {
    return <NotFound />;
  }
  return (
    <section className={styles.container} data-testid="Signin">
      <aside className={styles.sidebar}>
        <Sidebar isRecruiter={isRecruiter} />
      </aside>
      <main className={styles.main}>
        <Form className={styles.form} isRecruiter={isRecruiter} />
      </main>
    </section>
  );
};
